import { Seo } from '@frontend/shared/web';
import { useSearchParams } from 'react-router-dom';

import { AdminTabs } from '../../components/admin/AdminTabs';
import { InvitationsTab } from '../../components/admin/InvitationsTab';
import { MembersTab } from '../../components/admin/MembersTab';
import { Header } from '../../components/layout/Header';

const TABS = [
  { key: 'members', label: 'Membres' },
  { key: 'invitations', label: 'Invitations' },
] as const;

type AdminTab = (typeof TABS)[number]['key'];

const isAdminTab = (value: string | null): value is AdminTab => TABS.some(tab => tab.key === value);

/** Écran « Droits et accès » — réservé au profil `Extranet_Admin` (cf. `RequireDomain`). */
export const AdminRoute = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const rawTab = searchParams.get('tab');
  const tab: AdminTab = isAdminTab(rawTab) ? rawTab : 'members';

  // Changer d'onglet repart d'une pagination et d'un filtre vierges.
  const setTab = (next: AdminTab) => setSearchParams({ tab: next });

  return (
    <>
      <Seo title="Administration — Portail extranet" />
      <Header title="Administration" subtitle="Membres du portail, rôles, périmètres et invitations" />

      <div className="flex-1 overflow-y-auto">
        <div className="px-8 py-6 flex flex-col gap-5">
          <AdminTabs value={tab} onChange={setTab} items={TABS} />
          {tab === 'members' ? <MembersTab /> : <InvitationsTab />}
        </div>
      </div>
    </>
  );
};
